import React, {useEffect, useState} from 'react';
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";
import _axios from "../../../httpService";

const TaskViewSection = (props) => {

  const [tableData, setTableData] = useState({columns: [], data: []});
  const [showTable, setShowTable] = useState(false);
  useEffect(() => {
    if (props.phaseId !== undefined) {
      _axios.get("" + "").then((response) => {
        setShowTable(true)
      })
    }

  },[props])
  return (
    <>{
      showTable &&
      <ReactTabulator
        columns={tableData.columns}
        // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
        data={tableData.data}
        dataChanged={(newData) => console.log("dataChanged", newData)}
        options={TabulatorTableOptions.style1}
        // style={{height: "50vh"}}
      />
    }
    </>
  )
};

export default TaskViewSection;
